import { render, staticRenderFns } from "./parking_log_nciom.vue?vue&type=template&id=13d36abd&"
import script from "./parking_log_nciom.vue?vue&type=script&lang=js&"
export * from "./parking_log_nciom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports